<template>
  <BaseDataIterator :service="fetchData" nested>
    <template #default="dataIteratorProps">
      <div key="grid_view" class="p-4 bg-gray-100">
        <BaseGrid :columns="4" class="gap-4">
          <FacebookPageAdPostCard
            v-for="adPost in dataIteratorProps.data"
            :key="adPost.id"
            :ad-post="adPost"
          />
        </BaseGrid>
      </div>
    </template>
  </BaseDataIterator>
</template>

<script>
import { accountFacebookPageAdPostsClient } from '@/api/clients';
import FacebookPageAdPostCard from './FacebookPageAdPostCard.vue';

export default {
  components: {
    FacebookPageAdPostCard,
  },
  props: {
    facebookPage: {
      type: Object,
      required: true,
    },
    accountId: {
      type: String,
      required: true,
    },
    since: {
      type: String,
      default: '',
    },
    until: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      adPosts: [],
    };
  },
  methods: {
    fetchData() {
      return accountFacebookPageAdPostsClient.list(this.accountId, this.facebookPage.id, {
        fields: 'id,message,created_time,full_picture,permalink_url',
        ...(this.since ? { since: this.since } : {}),
        ...(this.until ? { until: this.until } : {}),
      });
    },
  },
};
</script>
